export default __webpack_public_path__ + "static/AppLocation5-f631d1fdafde504fbc48f825cf3039be.png";